// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5a6419ed","977":"35786bfa"}[chunkId] + ".chunk.js";
};